module.exports = __webpack_public_path__ + "img/ace3.f73fbd80.jpg";